import { INTTTokenResponse } from "./services";

declare global {
    interface Window {
        AtomPaynetz: any;
    }
}

export class NTTScript {
    private static loadScript(FILE_URL: string, async = true, type = "text/javascript") {
        return new Promise((resolve, reject) => {
            try {
                const scriptEle = document.createElement("script");
                scriptEle.type = type;
                scriptEle.async = async;
                scriptEle.src = FILE_URL;

                scriptEle.addEventListener("load", (ev) => {
                    resolve({ status: true });
                });

                scriptEle.addEventListener("error", (ev) => {
                    reject({
                        status: false,
                        message: `Failed to load the script ＄{FILE_URL}`
                    });
                });

                document.body.appendChild(scriptEle);
            } catch (error) {
                reject(error);
            }
        });
    }

    public static openPay(payload: INTTTokenResponse) {
        const url = payload.checkoutJsUrl;

        return this.loadScript(url)
            .then(() => {
                if (!window.AtomPaynetz) {
                    return Promise.reject("AtomPaynetz not loaded.")
                }

                const options = {
                    "atomTokenId": payload.token,
                    "merchId": payload.mid,
                    "custEmail": payload.eMail,
                    "custMobile": payload.phoneNumber,
                    "returnUrl": payload.callbackUrl
                }

                new window.AtomPaynetz(options, 'uat');
            })
            .catch(() => Promise.reject("AtomPaynetz not loaded."));
    }
}

